import { useMemo } from 'react';
import { useAppSelector } from './store/hooks';
import { UserAuthData } from './store/slices/authSlice';

export enum Permission {
  Anonymous = 'anonymous', // This permission is never returned by the api.
  CanAccess = 'dm_portal_can_access', // Customer communications
  SiteDataRead = 'dm_portal_site_read', // Access to most things
  PerformanceRead = 'dm_portal_performance_read', // Access to performance features
  PartnerRead = 'dm_portal_partner', // Partner/ITP features
  InvestigationsAll = 'dm_portal_investigations_all', // Read and write access to investigations
  FlagPreview = 'dm_portal_flag_preview', // Testing features
}

export const userHasPermission = (user: UserAuthData, permission: Permission): boolean => {
  return (
    permission === Permission.Anonymous ||
    (user.isLoggedIn && user.permissions.includes(permission))
  );
};

export const useIsUserWithPermission = (permission: Permission): boolean => {
  const user = useAppSelector(state => state.auth);

  const hasPermission = useMemo(() => userHasPermission(user, permission), [user, permission]);

  return hasPermission;
};
